<template>
	<li class="search_item">
		<a class="search_link" :href="linkUrl">
			<span class="search_thumbnail_wrapper" v-if="article.thumbnailUrl">
				<img class="search_thumbnail_img" :src="article.thumbnailUrl" width="52" height="52" alt="게시글 이미지"/>
			</span>
			<div class="search_content">
				<strong class="search_title" v-html="article.content"></strong>
				<span class="search_date">
					<span>{{ article.regdttm }}</span>
					<span class="search_dot"></span>
					<span>댓글 {{ article.commentCount.toLocaleString() }}</span>
				</span>
			</div>
		</a>
	</li>
</template>

<script>
export default {
	props: {
		config: Object,
		article: Object
	},
	computed: {
		linkUrl() {
			return `/${this.article.grpcode}/${this.article.fldid}/${this.article.dataid}?q=${this.config.searchKeyword}&searchCtx=${this.article.searchCtx}`;
		}
	}
}
</script>
